export default "__VITE_ASSET__BrsTMBFy__"